{
  "$schema": "https://zam.app/schemas/v1/kvt-tile.json",
  "tile_id": "de-by:realschule-8-englisch-grammar-conditional-reported-speech",
  "version": "2026.08.1",
  "title": "Englisch 8: Fortgeschrittene Grammatik – Conditional 3, Indirekte Rede, Past Perfect und Gerund (Realschule 8 Bayern)",
  "description": "Geerdetes KVT-Paket für Realschule Bayern Englisch 8: Conditional Sentences Type 3 (had + 3. Form / would have + 3. Form), Reported Speech (Backshift of Tenses), Past Perfect vs. Simple Past und Gerund vs. Infinitiv.",
  "publisher": "ZAM Curriculum Working Group",
  "published_at": "2026-08-15T23:15:00Z",
  "sources": [
    {
      "uri": "https://www.lehrplanplus.bayern.de/fachlehrplan/realschule/8/englisch",
      "checked": "2026-08-15",
      "label": "Realschule Englisch 8, Lernbereich Sprachliche Mittel und Grammatik"
    }
  ],
  "atoms": [
    {
      "id": "01K4E8G0000000000000000A01",
      "atom_uri": "urn:zam:atom:01K4E8G0000000000000000A01",
      "namespace": "englisch-grammatik",
      "slug": "conditional-type-3-unreal-past-condition",
      "title": "Conditional Sentences Type 3: Unmögliche Bedingung in der Vergangenheit ('had done' -> 'would have done')",
      "domain": "schule/englisch/grammatik",
      "reduction": "formal",
      "typical_age_min": 13.5,
      "prerequisites": [],
      "alignments": [
        {
          "target_uri": "http://www.wikidata.org/entity/Q1860",
          "target_label": "Conditional sentence",
          "alignment_type": "skos:broadMatch",
          "provenance": "manual_curation_v1"
        }
      ],
      "curricula": [
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 8,
          "subject": "englisch",
          "topic_code": "lb1",
          "topic_title": "Grammatik und Sprachliche Mittel",
          "exam_relevant": true
        }
      ],
      "practice_items": [
        {
          "id": "01K4E8G0000000000000000J01",
          "language": "de",
          "tier": "tier1_fast",
          "bloom_level": 1,
          "question": "Wie lautet die korrekte Verbform im Hauptsatz (Main Clause) eines Conditional Type 3 Satzes (z. B. 'If you had asked me, I ... [help] you')?",
          "concept": "would have helped (would have + Past Participle)",
          "fast_check": {
            "type": "binary_choice",
            "options": [
              "would have helped",
              "would help"
            ],
            "correct_index": 0
          }
        },
        {
          "id": "01K4E8G0000000000000000J02",
          "language": "de",
          "tier": "tier2_synthesis",
          "bloom_level": 2,
          "question": "Vergleiche die 3 Typen von Bedingungssätzen (If-Clauses) im Englischen: Type 1 (erfüllbare Bedingung: *if + Simple Present -> will + Infinitiv*), Type 2 (unwahrscheinliche Gegenwart: *if + Simple Past -> would + Infinitiv*), Type 3 (nicht mehr erfüllbare Vergangenheit: *if + Past Perfect -> would have + Past Participle*), erläutere das Verbot von 'would im if-Satz' und übersetze: a) 'Wenn sie den Wecker gestellt hätte, hätte sie den Zug nicht verpasst.' b) 'Wenn wir mehr gelernt hätten, hätten wir den Test bestanden.'",
          "concept": "3 If-Satz-Typen; Type 3: If + had + 3. Form, Main clause: would have + 3. Form; niemals 'would' im if-Teil; a) 'If she had set the alarm clock, she wouldn't have missed the train.' b) 'If we had studied more, we would have passed the test.'",
          "sample_solution": "1. Synopse der 3 Conditional Clause Typen: - **Type 1 (Real condition in future / Erfüllbare Bedingung)**:   * *If-clause*: **Simple Present** | *Main clause*: **will-Future / Modalverb + Infinitiv**   * *'If it rains tomorrow, we will stay at home.'* - **Type 2 (Unreal condition in present / Theoretisch denkbare Gegenwart)**:   * *If-clause*: **Simple Past** | *Main clause*: **would + Infinitiv**   * *'If I had enough money, I would buy a car.'* - **Type 3 (Impossible condition in past / Nicht mehr änderbare Vergangenheit)**:   * Beschreibt ein vergangenes Ereignis, das **nicht eingetreten ist** und nachträglich nicht mehr verändert werden kann (Bedauern, Vorwurf, hypothetische Rückschau).   * *If-clause*: **Past Perfect (had + Past Participle / 3. Form)**   * *Main clause*: **would have / could have / might have + Past Participle (3. Form)**.   * *Eiserne Grundregel*: **Niemals 'would' im if-Satz!** (*'If I would have...'* ist falsch!). 2. Übersetzungen: - a) 'Wenn sie den Wecker gestellt hätte, hätte sie den Zug nicht verpasst.' $\\rightarrow$ **« If she had set the alarm clock, she wouldn't have missed the train. »** - b) 'Wenn wir mehr gelernt hätten, hätten wir den Test bestanden.' $\\rightarrow$ **« If we had studied (more), we would have passed the test. »**"
        }
      ]
    },
    {
      "id": "01K4E8G0000000000000000A02",
      "atom_uri": "urn:zam:atom:01K4E8G0000000000000000A02",
      "namespace": "englisch-grammatik",
      "slug": "reported-speech-backshift-of-tenses-pronoun-time-shift",
      "title": "Reported Speech (Indirekte Rede): Der Zeitensprung (Backshift of Tenses) und Pronomenanpassung",
      "domain": "schule/englisch/grammatik",
      "reduction": "formal",
      "typical_age_min": 13.5,
      "prerequisites": [
        {
          "atom_id": "01K4E8G0000000000000000A01",
          "type": "hard",
          "rationale": "Beherrschung aller Zeitformen ist Voraussetzung für den Backshift of Tenses."
        }
      ],
      "alignments": [
        {
          "target_uri": "http://www.wikidata.org/entity/Q1860",
          "target_label": "Indirect speech",
          "alignment_type": "skos:broadMatch",
          "provenance": "manual_curation_v1"
        }
      ],
      "curricula": [
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 8,
          "subject": "englisch",
          "topic_code": "lb1",
          "topic_title": "Grammatik und Sprachliche Mittel",
          "exam_relevant": true
        }
      ],
      "practice_items": [
        {
          "id": "01K4E8G0000000000000000J03",
          "language": "de",
          "tier": "tier1_fast",
          "bloom_level": 1,
          "question": "In welche Zeitform wandelt sich das Simple Past der direkten Rede ('I lost my wallet'), wenn der Einleitungssatz in der Vergangenheit steht ('He said that...')?",
          "concept": "Ins Past Perfect: 'He said that he had lost his wallet.'",
          "fast_check": {
            "type": "binary_choice",
            "options": [
              "Past Perfect (had lost)",
              "Simple Present (loses)"
            ],
            "correct_index": 0
          }
        },
        {
          "id": "01K4E8G0000000000000000J04",
          "language": "de",
          "tier": "tier2_synthesis",
          "bloom_level": 2,
          "question": "Erkläre die Regeln für Reported Speech mit vergangenem Einleitungssatz (*said, told, explained*): 1. **Backshift of Tenses (Verschiebung um eine Zeitstufe in die Vergangenheit)**: Simple Present -> Simple Past; Present Continuous -> Past Continuous; Simple Past / Present Perfect -> Past Perfect; will -> would; can -> could, 2. **Anpassung der Personal- und Possessivpronomen** (*I -> he/she, my -> his/her*), 3. **Anpassung von Orts- und Zeitangaben** (*now -> then, today -> that day, yesterday -> the day before, tomorrow -> the next day, here -> there*) und wandle folgende Sätze in Reported Speech um: a) Tom: 'I am playing football today.' -> *Tom said that...* b) Sarah: 'I visited London last year.' -> *Sarah explained that...*",
          "concept": "Reported Speech: 1. Backshift of Tenses (alle Zeiten eine Stufe zurück); 2. Pronomen anpassen; 3. Zeit-/Ortsadverbien anpassen; a) 'Tom said that he was playing football that day.' b) 'Sarah explained that she had visited London the year before.'",
          "sample_solution": "1. Die 3 Transformationsregeln der Reported Speech: - Steht das einleitende Verb in der Vergangenheit (*He said, she told me, they asked*), müssen 3 Anpassungen vorgenommen werden: - **1. Der Zeitensprung (Backshift of Tenses)**:   * **Simple Present** $\\rightarrow$ **Simple Past** (*like $\\rightarrow$ liked*)   * **Present Continuous** $\\rightarrow$ **Past Continuous** (*is working $\\rightarrow$ was working*)   * **Simple Past** $\\rightarrow$ **Past Perfect** (*went $\\rightarrow$ had gone*)   * **Present Perfect** $\\rightarrow$ **Past Perfect** (*has seen $\\rightarrow$ had seen*)   * **Past Perfect** $\\rightarrow$ bleibt **Past Perfect**   * **will** $\\rightarrow$ **would** | **can** $\\rightarrow$ **could** | **may** $\\rightarrow$ **might** | **must** $\\rightarrow$ **had to**. - **2. Pronomenverschiebung (Pronouns)**:   * Sprecherperspektive anpassen: *'I'* $\\rightarrow$ *he/she*; *'my'* $\\rightarrow$ *his/her*; *'we'* $\\rightarrow$ *they*. - **3. Verschiebung von Zeit- und Ortsangaben (Adverbials)**:   * *now* $\\rightarrow$ *then*   * *today* $\\rightarrow$ *that day*   * *yesterday* $\\rightarrow$ *the day before / the previous day*   * *tomorrow* $\\rightarrow$ *the next day / the following day*   * *last week* $\\rightarrow$ *the week before*   * *ago* $\\rightarrow$ *before*   * *here* $\\rightarrow$ *there* | *this* $\\rightarrow$ *that*. 2. Lösung der Transformationsaufgaben: - **a) Tom: 'I am playing football today.'**   * $\\rightarrow$ **« Tom said that he was playing football that day. »**   * (*I $\\rightarrow$ he*, *am playing $\\rightarrow$ was playing*, *today $\\rightarrow$ that day*). - **b) Sarah: 'I visited London last year.'**   * $\\rightarrow$ **« Sarah explained that she had visited London the year before (the previous year). »**   * (*I $\\rightarrow$ she*, *visited $\\rightarrow$ had visited*, *last year $\\rightarrow$ the year before*)."
        }
      ]
    }
  ]
}
